<section id="home" class="slider_area">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="slider-content">&nbsp;</div>
        </div>
    </div>
</section>

<div class="contact-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="contact-info">
                    <h2>{{ 'CONTACT.TITLE' | translate }}</h2>
                    <p>{{ 'CONTACT.DESCRIPTION' | translate }}</p>
                    
                    <div class="info-item">
                        <i class="lni lni-phone"></i>
                        <div class="info-content">
                            <h4>{{ 'CONTACT.PHONE' | translate }}</h4>
                            <p>+40 743 366 266</p>
                        </div>
                    </div>
                    
                    <div class="info-item">
                        <i class="lni lni-envelope"></i>
                        <div class="info-content">
                            <h4>{{ 'CONTACT.EMAIL' | translate }}</h4>
                            <p>contact@propero.io</p>
                        </div>
                    </div>
                    
                    <div class="info-item">
                        <i class="lni lni-map-marker"></i>
                        <div class="info-content">
                            <h4>{{ 'CONTACT.ADDRESS' | translate }}</h4>
                            <p>Brasov, Romania</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-6">
                <div class="contact-form">
                    <form #contactForm="ngForm" (ngSubmit)="send()">
                        <div class="form-group">
                            <input type="text" class="form-control" 
                                name="name"
                                placeholder="{{ 'CONTACT.NAME' | translate }}"
                                [(ngModel)]="contactItem.subject" 
                                required>
                        </div>
                        
                        <div class="form-group">
                            <input type="email" class="form-control" 
                                name="email"
                                placeholder="{{ 'CONTACT.EMAIL' | translate }}"
                                [(ngModel)]="contactItem.email" 
                                required 
                                email>
                        </div>
                        
                        <div class="form-group">
                            <textarea class="form-control" 
                                rows="5" 
                                name="message"
                                placeholder="{{ 'CONTACT.MESSAGE' | translate }}"
                                [(ngModel)]="contactItem.content" 
                                required></textarea>
                        </div>
                        
                        <button 
                            type="submit" 
                            class="btn btn-primary"
                            [disabled]="contactForm.invalid || isLoading"
                            [ngClass]="{'loading': isLoading}"
                        >
                            <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
                            <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div> 